import { MedicalImageViewOptions } from '@/shared/api/protocol-ts/model/dto_common_image_view_options_pb';

export const makeImageViewOptions = (viewOptions?: MedicalImageViewOptions) => {
  const options = {
    sharpness: viewOptions?.Sharpness ?? 0,
    invert: viewOptions?.Invert ?? false,
    brightness: viewOptions?.Brightness ?? 0,
    contrast: viewOptions?.Contrast ?? 0,
    wwwc: {
      ww: viewOptions?.WindowWidth ?? 0,
      wc: viewOptions?.WindowLevel ?? 0,
    },
  };

  return options;
};
